import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'countrySort',
    standalone: false
})
export class CountrySortPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(inputList: any[], labelKey?: string, translatedLabel = true): any[] {
    // Turkish alphabet with proper sorting order
    const alphabet = 'abcçdefgğhıijklmnoöpqrsştuüvwxyz';

    // Define a custom sorting function with bound context
    const sortFunc = ((a: any, b: any): number => {
      let labelA: string = labelKey ? a[labelKey] : a;
      let labelB: string = labelKey ? b[labelKey] : b;

      // Put Turkey at the top of the list
      const isTurkeyA = labelA.toLowerCase() === 'turkey';
      const isTurkeyB = labelB.toLowerCase() === 'turkey';
      if (isTurkeyA && !isTurkeyB) {
        return -1;
      } else if (!isTurkeyA && isTurkeyB) {
        return 1;
      }

      if (translatedLabel) {
        labelA = this.translate.instant('general.' + labelA);
        labelB = this.translate.instant('general.' + labelB);
      }

      labelA = labelA.toLowerCase();
      labelB = labelB.toLowerCase();

      // Proceed with regular sorting
      for (let i = 0; i < Math.min(labelA.length, labelB.length); i++) {
        const indexA = alphabet.indexOf(labelA[i]);
        const indexB = alphabet.indexOf(labelB[i]);
        if (indexA !== indexB) {
          return indexA - indexB;
        }
      }

      // If labels are equal up to the length of the shorter label, sort based on label length
      return labelA.length - labelB.length;
    }).bind(this); // Bind the context
    inputList = inputList?.length > 0 ? inputList : [];
    // Sort the list using the custom sorting function
    return inputList.sort(sortFunc);
  }
}
